
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/event/[eventId]",
      function () {
        return require("private-next-pages/[publicId]/event/[eventId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/event/[eventId]"])
      });
    }
  